import styled from "styled-components";

const TeamStyleWrapper = styled.section`
  background-repeat: no-repeat;
  background-position: center;
  padding: 115px 0 85px;

  .section_title {
    text-align: center;
    margin-bottom: 45px;
  }
`;

export default TeamStyleWrapper;
